module.exports = __webpack_public_path__ + "static/media/flex-plus-white-horizontal.d2d685ed.svg";